import { Component, inject } from '@angular/core';
import { IncidentService } from '../proxy/operational/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IncidentCreateDto,
  IncidentDto,
  IncidentExcelDownloadDto,
  IncidentUpdateDto,
} from '../proxy/operational/dtos/incident';
import { INCIDENT_CONFIG, INCIDENT_FIELDS } from './incident.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-incident',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IncidentService, ConfirmationService],
  templateUrl: './incident.html',
  styleUrl: './incident.scss',
})
export class Incident extends BaseCrudComponent<
  IncidentDto,
  IncidentCreateDto,
  IncidentUpdateDto,
  IncidentExcelDownloadDto
> {
  service = inject(IncidentService);
  config = INCIDENT_CONFIG;
  fields = INCIDENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: IncidentDto): IncidentUpdateDto {
    return {
      isAuthorized: data.isAuthorized,
      incidentDate: data.incidentDate,
      area: data.area,
      notes: data.notes,
      oldIncidentReference: data.oldIncidentReference,
      number: data.number,
      incidentTypeId: data.incidentTypeId,
      incidentCauseId: data.incidentCauseId,
      intensityDegreeId: data.intensityDegreeId,
      incidentOriginId: data.incidentOriginId,
      incidentDetectionId: data.incidentDetectionId,
      userId: data.userId,
      authorizationUserId: data.authorizationUserId,
      mainDiagnosisId: data.mainDiagnosisId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Incident';
  }
}
